import { Link } from 'react-router-dom';
import PageHero from '../components/PageHero';
import { heroSubtitleClass, heroTitleClass, motionSafe } from '../constants/heroTypography';
import bannerImage from '../assets/img/ic_our_service_background.png';
import services from '../data/services';
import ic1 from '../assets/img/ic_our_service_1.png';
import ic2 from '../assets/img/ic_our_service_5.png';
import ic3 from '../assets/img/ic_our_service_3.png';
import ic4 from '../assets/img/ic_our_service_4.png';
import ic5 from '../assets/img/ic_our_service_2.png';
import ic6 from '../assets/img/ic_our_service_7.png';
import ic7 from '../assets/img/ic_our_service_6.png';
import destinationWeddingsIcon from '../assets/img/destinationweddings.png';
import limousineChauffeurIcon from '../assets/img/Limousine_Chauffeur_Services.png';
import talentAcquisitionIcon from '../assets/img/talentacquisition.png';
import medicalTourismIcon from '../assets/img/ic_our_service_1.png';

const serviceIcons = [
  ic1,
  ic2,
  ic3,
  ic4,
  ic5,
  ic6,
  ic7,
  destinationWeddingsIcon,
  limousineChauffeurIcon,
  talentAcquisitionIcon,
  medicalTourismIcon,
];

const clamp2 =
  'overflow-hidden text-ellipsis [display:-webkit-box] [-webkit-box-orient:vertical] [-webkit-line-clamp:2]';

function ServiceIcon({ idx }) {
  const src = serviceIcons[idx % serviceIcons.length];
  return (
    <div className="mx-auto mb-5 flex h-[92px] w-[92px] items-center justify-center rounded-2xl bg-white/5 ring-1 ring-gold/40 shadow-[0_0_0_1px_rgba(212,175,55,0.12),0_18px_40px_rgba(0,0,0,0.35)]">
      <img src={src} alt="" aria-hidden className="h-[92px] w-[92px] object-contain p-2" />
    </div>
  );
}

export default function Services() {
  return (
    <div className="bg-navy-950">
      <PageHero
        title="How We Can Help You"
        subtitle="At RAYAN STAR Consultancy, we provide professional and reliable solutions designed to make your journey smooth, successful, and stress-free."
        backgroundImage={bannerImage}
        titleClassName={heroTitleClass}
        subtitleClassName={heroSubtitleClass(motionSafe)}
      />

      {/* Cards */}
      <section className="relative py-16 sm:py-20" aria-labelledby="services-grid-heading">
        <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <p
              id="services-grid-heading"
              className="text-sm font-semibold tracking-[0.35em] text-white/80 sm:text-base"
            >
              <span className="text-white">OUR</span> <span className="text-gold">SERVICES</span>
            </p>
            <div className="mx-auto mt-3 h-px w-16 bg-gradient-to-r from-transparent via-gold/80 to-transparent" />
          </div>

          <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-2">
            {services.map((s, idx) => (
              <article
                key={s.slug}
                className={`group relative overflow-hidden rounded-2xl border border-slate-200 bg-white p-7 text-center shadow-md transition hover:-translate-y-1.5 hover:border-gold/50 hover:shadow-xl motion-reduce:hover:translate-y-0 ${motionSafe} animate-fade-in-up`}
                style={{ animationDelay: `${120 + idx * 90}ms` }}
              >
                <div
                  className="pointer-events-none absolute inset-0 opacity-0 transition-opacity duration-300 group-hover:opacity-100"
                  style={{
                    background: 'radial-gradient(520px 260px at 50% 10%, rgba(212,175,55,0.16), transparent 60%)',
                  }}
                  aria-hidden
                />
                <ServiceIcon idx={idx} />
                <h3 className={`relative text-balance font-serif text-lg font-semibold text-navy ${clamp2}`}>
                  {s.title}
                </h3>
                <p className={`relative mt-3 text-center text-sm leading-relaxed text-navy/70 ${clamp2}`}>
                  {s.short}
                </p>
                <Link
                  to={`/services/${s.slug}`}
                  className="relative mt-6 inline-flex items-center justify-center gap-2 rounded-md bg-navy px-5 py-2.5 text-xs font-semibold tracking-wide text-white transition hover:bg-navy-800"
                >
                  View Details <span aria-hidden>→</span>
                </Link>
              </article>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

